import type { Process } from "@certa/studio-core";
import { forwardParseSync as forwardParseSyncFromStudioParser } from "@certa/studio-parser";
import { captureException } from "@sentry/react";

export const forwardParseSyncWithSentry = ({
  metaJSON,
  shouldIgnoreInvalidReferences,
  shouldIgnoreEventsIds
}: {
  metaJSON: Process;
  shouldIgnoreInvalidReferences?: boolean;
  shouldIgnoreEventsIds?: boolean;
}) => {
  try {
    return forwardParseSyncFromStudioParser({
      metaJSON,
      shouldIgnoreInvalidReferences
    });
  } catch (e: unknown) {
    captureException(
      new Error(
        `Forward Parser Sync Failed for Process ID: ${metaJSON?.process?.id} with the following error, ${e}`
      )
    );
    throw e;
  }
};
